module.exports = __webpack_public_path__ + "static/media/Sahabat Lampu Baca (1).d89e1596.jpeg";